module.exports = __webpack_public_path__ + "static/media/cs-logo.24405426.svg";